<template>
  <component v-bind="containerTag.props" :is="containerTag.name">
    <slot name="before-name" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.name || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.nameInput || {}), ...textFieldProps }"
        v-model="input.name"
        placeholder="Campaign Name"
      />
    </component>
    <slot v-if="!put" name="before-app" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.app || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-model="input.app"
        :items="apps"
        item-text="phone_number"
        :item-value="(v) => v"
        no-data-text="No Apps for this channel"
        placeholder="Select App"
        outline
      />
    </component>
    <slot v-if="!put" name="before-template" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.app || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-model="input.message"
        :items="templateMessagesOptions"
        placeholder="Template Message"
        item-text="text"
        item-value="value"
        outline
      />
    </component>
    <slot v-for="(slot, s) in new Array(slots)" :name="`tail-slot-${s + 1}`" />
  </component>
</template>

<script>
export default {
  name: "AddCampaign",
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true,
        };
      },
    },
    slots: {
      type: Number,
      default: 2,
    },
    customBind: {
      type: Object,
      default() {
        return {};
      },
    },
    put: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isValid: false,
      bot_whatsapp_provider: "",
      apps: [],
      input: {
        name: "",
        channel: "whatsapp",
        message_type: "OUTBOUND",
        app: null,
        message: null,
      },
    };
  },
  watch: {
    put(val) {
      if (val) this.input = val;
      else this.resetForm();
    },
  },
  async mounted() {
    await this.getApps();

    await this.getTemplateMessages();
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    templateMessagesOptions() {
      if (!this.input.app) return [];
      return this.$store.state.campaigns.templateMessages
        .filter((t) => {
          let status;

          if (Array.isArray(t.status)) {
            status = t.status[0].value;
          } else {
            status = t.status;
          }

          t.status = status;
          return (
            status === "APPROVED" &&
            (t.app.id === this.input.app.app_id ||
              t.app.whatsapp_business_account_id ===
                this.input.app.whatsapp_business_account_id)
          );
        })
        .map((t) => ({ text: `${t.name} (${t.status})`, value: t._id }));
    },
  },
  methods: {
    async getApps() {
      this.input.app = null;
      if (!this.botId) return;
      const response = await this.$http_session_manager.get(
        `/bots/${this.botId}/apps/whatsapp/list`
      );
      let data = response.data;
      this.bot_whatsapp_provider = data.whatsapp_provider;

      this.apps = data.whatsapp_apps.filter(
        (a) => a && a.status.toLowerCase() === "connected"
      );
    },
    async getTemplateMessages() {
      await this.$store.dispatch("templatemessages/get", null);
      await this.$store.dispatch("templatesettings/get", null);
    },
    async submit() {
      this.$store.dispatch("setLoader", true);
      if (
        this.input.name.length &&
        this.input.channel.length &&
        this.input.app
      ) {
        const botId = this.$store.state.bot.botId;
        const formPayload = this.put
          ? { name: this.put.name, id: this.put._id }
          : { ...this.input, bot_id: this.$store.state.bot.botId };
        let payload = {
          bot_id: botId,
          ...formPayload,
        };
        if (!this.put) {
          payload.app = {
            name: payload.app.name,
            provider: "whatsapp",
            id: payload.app.app_id,
            phone_number: payload.app.phone_number,
            phone_number_id: payload.app.phone_number_id,
            whatsapp_business_account_id:
              payload.app.whatsapp_business_account_id,
          };
        }
        const response = await this.$store.dispatch(
          `campaigns/${this.put ? "update" : "add"}`,
          payload
        );

        this.$store.dispatch("setLoader", false);
        this.resetForm();
        this.$emit("success", response);
      }
    },
    resetForm() {
      this.input = {
        name: "",
        channel: "whatsapp",
        message_type: "INBOUND",
      };
      return true;
    },
  },
};
</script>

<style lang="css" scoped>
.platform-wrapper {
  border-radius: 50%;
  padding: 5px;
  height: 30px;
  width: 30px;

  font-size: 20px;
}
</style>
